import { render, staticRenderFns } from "./selectField.vue?vue&type=template&id=4f535a5e&scoped=true&lang=pug&"
import script from "./selectField.vue?vue&type=script&setup=true&lang=js&"
export * from "./selectField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./selectField.vue?vue&type=style&index=0&id=4f535a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f535a5e",
  null
  
)

export default component.exports